// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9eb00ecb","490":"c278b267","967":"519a97f6"}[chunkId] + ".chunk.js";
};